import React from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Button,
  Image,
  Spinner,
} from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { useForm } from "react-hook-form";
import api from "../../../utils/helper";
import { useAuth } from "../../../context/AuthContext";
import { useIDsContext } from "../../../context/IDsContext";
import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";
import "../../teacher/index.css";

const VendorLogin = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const navigate = useNavigate();
  const { login } = useAuth();
  const { setVendorID, setVendorName } = useIDsContext();

  const loginMutation = useMutation({
    mutationFn: (credentials) =>
      api.login("/auth/login", credentials, "vendor"),
    onSuccess: (response) => {
      console.log(response, "okokok");
      localStorage.clear();
      const userData = response?.data?.data?.user;

      // Store in localStorage
      localStorage.setItem("email", userData?.email);
      localStorage.setItem("profile_img", userData?.profile_img);
      login(
        response?.data?.data?.user?.firstname,
        "vendor",
        response?.data?.data?.token,
        response?.data?.data?.user?._id
      );
      setVendorID(response?.data?.data?.user?._id);
      setVendorName(response?.data?.data?.user?.name);
      navigate("/vendor/");
    },
     onError: (err) => {

      const user = err.response?.data?.data;

      if (user?.isVerified == 'NOT VERIFIED') {
        navigate('/vendor/add-mobile', { state: { email: user?.user?.email, role: 'vendor' } })
      }
    }
  });

  const handleLogin = (data) => {
    loginMutation.mutate({ ...data, role: "vendor" });
  };

  const handleForgotPassword = async () => {
    navigate("/vendor/forgot-password");
  };

  return (
    <Container fluid className="h-100">
      {console.log(loginMutation, "loginMutation")}
      <Row className="h-100 position-relative">
        <Col
          md={12}
          className="d-flex align-items-center p-0"
          style={{
            backgroundImage: "url('/images/Login.jpg')",
            backgroundSize: "cover",
            backgroundPosition: "center",
            minHeight: "100vh",
          }}
        >
          <div
            style={{
              position: "absolute",
              right: "55px",
              top: "30px",
            }}
          >
            <Image
              src="/images/image 1.png"
              style={{ height: "90px", width: "160px" }}
            />
          </div>
          <div className="login-card card-border">
            <Card className=" shadow card-border">
              <Card.Header className="d-flex card-border align-items-center justify-content-between p-3 login-header">
                <img
                  src="/images/logoblue.png"
                  alt="Logo"
                  className="me-3"
                  style={{ height: "35px" }}
                />
                <h4 className="mb-0 fw-bold login-title">Admin Panel</h4>
              </Card.Header>

              <Card.Body>
                <Form
                  onSubmit={handleSubmit(handleLogin)}
                  className="w-75 m-auto"
                >
                  <div className="text-center welcome-text mb-3">
                    <Form.Text>
                      Welcome! Please, enter your credentials
                    </Form.Text>
                  </div>
                  <Form.Group className="mb-3">
                    <Form.Label>Email</Form.Label>
                    <Form.Control
                      type="email"
                      placeholder="Enter your email"
                      {...register("email", {
                        required: "Email is required",

                        pattern: {
                          value:
                            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                          message: "Invalid email format",
                        },
                      })}
                    />
                    {errors.email && (
                      <p className="text-danger family-inter">
                        {errors.email.message}
                      </p>
                    )}
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Password</Form.Label>
                    <Form.Control
                      type="password"
                      placeholder="••••••••"
                      {...register("password", {
                        required: "Password is required",

                        minLength: {
                          value: 6,
                          message: "Password must be at least 6 characters",
                        },
                      })}
                    />
                    {errors.password && (
                      <p className="text-danger family-inter">
                        {errors.password.message}
                      </p>
                    )}
                  </Form.Group>

                  <Form.Group className="mb-3 d-flex justify-content-between align-items-center">
                    <Form.Check
                      type="checkbox"
                      label="Remember me"
                      // checked={rememberMe}
                      //  onChange={(e) => setRememberMe(e.target.checked)}
                    />
                  </Form.Group>

                  {loginMutation?.error && (
                    <p className="text-danger family-inter">
                      {loginMutation?.error?.response?.data?.message ||
                        "Login Failed!"}
                    </p>
                  )}

                  <Button
                    variant="primary"
                    type="submit"
                    className="w-100 mb-3"
                  >
                    {loginMutation.isLoading ? (
                      <span className=" text-white">
                        {" "}
                        <Spinner size="sm" /> Loading...
                      </span>
                    ) : (
                      "Sign in"
                    )}
                  </Button>
                </Form>
              </Card.Body>

              <Card.Footer className="p-0"></Card.Footer>
            </Card>
            <Button
              variant="outline-secondary"
              className="forgot-btn color-white border-none"
              onClick={
                /* Implement forgot password logic */
                handleForgotPassword
              }
              style={{
                height: "43px",
                display: "flex",
                justifyContent: "center",
                gap: "2%",
                textAlign: "center",
                alignItems: "center",
              }}
            >
              Forgot password?{" "}
              <a
                className="btnhere text-white"
                style={{ textDecoration: "underline" }}
              >
                Reset here
              </a>
            </Button>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default VendorLogin;
